import MasterIcon from "@/assets/icons/cards/master.svg?react";
import VisaIcon from "@/assets/icons/cards/visa.svg?react";
import DiscoverIcon from "@/assets/icons/cards/discover.svg?react";
import DinersIcon from "@/assets/icons/cards/diners.svg?react";
import PlaceholderIcon from "@/assets/icons/cards/placeholder.svg?react";
import AmexIcon from "@/assets/icons/cards/amex.svg?react";
import JcbIcon from "@/assets/icons/cards/jcb.svg?react";
import UnionPayIcon from "@/assets/icons/cards/unionpay.svg?react";
import HipercardIcon from "@/assets/icons/cards/hipercard.svg?react";

import { CardImages } from "react-payment-inputs/images";

export const cardImages: CardImages = {
  amex: <AmexIcon />,
  dinersclub: <DinersIcon />,
  discover: <DiscoverIcon />,
  hipercard: <HipercardIcon />,
  jcb: <JcbIcon />,
  unionpay: <UnionPayIcon />,
  mastercard: <MasterIcon />,
  placeholder: <PlaceholderIcon />,
  visa: <VisaIcon />,
};
